import { OreDivider, OreHeading, OreStack, OreText } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { SITE_INFO } from '@/Shared/constants/siteInfo'
import { PageWrapper } from '@/Shared/ui/layout'
import { StoreStickersForm } from '@/Store/ui/organisms'
import { storesTranslation } from '@/Store/ui/storesTranslation'
import { useUserData } from '@/User/ui/context'

export const StoreStickersPage = (): JSX.Element => {
  const { t } = useTranslation()
  const { merchant } = useUserData()

  return (
    <PageWrapper
      paddingSmaller
      paddingTop={8}
      style={{
        paddingRight: 40,
        paddingLeft: 40,
        minWidth: '-webkit-fill-available',
        marginRight: 0,
        marginLeft: 0,
      }}
    >
      <OreHeading as="h1" size="title-sm">
        {t(storesTranslation.stickers.pageTitle)}
      </OreHeading>
      <OreDivider space="larger-bottom" />

      <OreStack direction="column" space="2xlarge" placeContent="stretch">
        <OreText style={{ whiteSpace: 'pre-line' }}>
          {merchant?.isNursery
            ? t(storesTranslation.stickers.introduction.guarderiaContent)
            : t(storesTranslation.stickers.introduction.content)}{' '}
          {
            <a
              href={`mailto: ${SITE_INFO.contact.email}?subject=${t(storesTranslation.stickers.introduction.subject)}`}
            >
              {SITE_INFO.contact.email}
            </a>
          }
        </OreText>
        <StoreStickersForm />
      </OreStack>
    </PageWrapper>
  )
}
